export default __webpack_public_path__ + "static/media/FlyingFrog22.8e28f1a4.png";